var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._b({attrs:{"value":_vm.snackbar.show,"color":_vm.snackbar.color,"timeout":_vm.snackbar.timeout},on:{"input":function($event){return _vm.closeSnackbar($event)}}},'v-snackbar',_vm.$attrs,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.snackbar.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }